import React, { useState } from 'react';
import {
  Upload, Button, message, Card, Typography, Space, Alert,
} from 'antd';
import { UploadOutlined, InfoCircleOutlined } from '@ant-design/icons';
import * as api from 'util/api';

const { Text } = Typography;

const KountaImport = () => {
  const [uploading, setUploading] = useState(false);
  const [result, setResult] = useState(null);

  const handleUpload = async (info) => {
    const { file } = info;
    setUploading(true);
    setResult(null);

    try {
      const data = await api.importKountaCsv(file);
      setResult(data);
      message.success(`Import complete: ${data.created} new, ${data.updated} updated`);
    } catch (err) {
      message.error('Failed to import Kounta CSV');
      console.error(err);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div style={{ maxWidth: 640 }}>
      <Card title="Kounta product cache" extra={<Text type="secondary">Product Database</Text>}>
        <Alert
          message="CSV import"
          description="Upload a Kounta product CSV export to populate the local cache. Linked products can be matched to Matrix SKUs from the Product Editor SKU tab."
          type="info"
          icon={<InfoCircleOutlined />}
          showIcon
          style={{ marginBottom: 24 }}
        />

        <Space direction="vertical" style={{ width: '100%' }} size="middle">
          <div>
            <Upload
              accept=".csv"
              showUploadList={false}
              customRequest={handleUpload}
              disabled={uploading}
            >
              <Button
                type="primary"
                icon={<UploadOutlined />}
                loading={uploading}
              >
                {uploading ? 'Importing…' : 'Import Kounta CSV'}
              </Button>
            </Upload>
          </div>

          {result && (
            <Alert
              message="Import complete"
              description={(
                <>
                  {result.total}
                  {' '}
                  rows processed:
                  {' '}
                  {result.created}
                  {' '}
                  new,
                  {' '}
                  {result.updated}
                  {' '}
                  updated,
                  {' '}
                  {result.unchanged}
                  {' '}
                  unchanged.
                </>
              )}
              type="success"
              showIcon
            />
          )}
        </Space>
      </Card>
    </div>
  );
};

export default KountaImport;
